import classNames from 'classnames'
import React from 'react'

import { ReactComponent as ArrowStopper } from '~/assets/icons/arrow-stopper.svg'

interface Properties {
  className?: string
}

import styled from './dashed-divider.module.css'

const DashedDivider: React.FC<Properties> = ({ className }) => {
  return (
    <div
      className={classNames(
        'relative w-full z-30 h-6 -my-3 flex items-center',
        className
      )}
    >
      <ArrowStopper className="absolute left-0" width={8} height={16} />
      <div
        className={classNames('w-[calc(100%-16px)] h-[2px]', styled.dashed)}
      />
      <ArrowStopper
        className="absolute right-0 rotate-180"
        width={8}
        height={16}
      />
    </div>
  )
}

export default DashedDivider
